import { Controller } from "../../ts/controller";
import { Logger } from "../../ts/utils/logger";

export class ForumCommentListItemController extends Controller {
    constructor() {
        super({
            logLabel: 'ForumCommentListItemController',
        });
    }

    public initialize(): void {
        this._setState();
        Logger.info(this.logLabel, 'Initialized');
    }

    private _setState(): void {
    }
}